<template>
  <div class="container-edificios">
    
    <div class="row">
      <div class="col-sm-12">
      <h1>Gerenciamento de edificios </h1><br>
    </div>

<div class="form-group col-sm-6">
          <label>Busca:</label>
          <input type="text"  class="form-control" value="" v-model="busca">
        </div>
<button  @click="getEdificios" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">BUSCAR</button>

<div class=" col-sm-12"></div>


          <div class="form-group col-sm-4">
          <label>Nome do edificio:</label>
          <input type="text" name="edificio" class="form-control" value="" v-model="edificio">
        </div>

          <button v-if="edificioSelecionado == null" @click="addEdificio()" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">+ADICIONAR</button>
          <button v-if="edificioSelecionado != null" @click="applyUpdates()" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">SALVAR ALTERAÇÕES</button>

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

          <div v-if="edificioSelecionado != null" class="form-group col-sm-12">
          <label>Descrição do edificio:</label>
          <textarea name="descricao" class="form-control" v-model="descricao"></textarea>
        </div>

    </div><!-- row -->


    <div class="row">

 <table class="col-sm table table-striped table-dark">
  <thead>
    <tr>
      
      <th scope="col">Edificio</th>
      <th scope="col">Editar Descrição</th>
      <th scope="col">Deletar</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(item, index ) in edificios" :key="item.ED_ID" >
      
      <td>
         <input type="text" :data-codigo="item.ED_ID" name="setEdificio" @keyup.enter="updateEdificio" class="form-control" :value="item.ED_NOME">
       </td>
     
     <td><button type="button" :data-codigo="index" class="btn btn-warning" @click="updateDescricao">Editar</button></td>
      
      <td><button type="button" :data-codigo="item.ED_ID" class="btn btn-danger" @click="deleteEdificio">Deletar</button></td>
    </tr>
   
  </tbody>
</table>

    </div><!-- row table -->



  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Edificio',
  components: {},
 
  data(){
      return {
          edificios:[],
          edificio:'',
          descricao:'',
          edificioSelecionado:null,
          loading: false,
          busca:''
      }
  },
 

methods:{
    addEdificio(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/novoEdificio',{edificio:this.edificio})
          .then( () => this.getEdificios())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;this.edificio = ''})
      },

      applyUpdates(){
          this.loading = true;
          this.edificioSelecionado.ED_NOME = this.edificio;
          this.edificioSelecionado.ED_DESCRICAO = this.descricao;
       
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/atualizarEdificio',this.edificioSelecionado)
          .then( () => this.getEdificios())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;this.edificio = '',this.descricao = '',this.edificioSelecionado = null;alert("Alterações feitas com sucesso!");})
      },


    getEdificios(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getEdificios',{edificio:this.edificio,busca:this.busca})
          .then(response => this.edificios = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    updateEdificio(event){
          let codigo = event.target.dataset.codigo
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/setEdificio',{edificio:event.target.value,id:codigo})
          .then( () =>  this.getEdificios())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    },

      updateDescricao(event){
          let index = event.target.dataset.codigo
          this.edificioSelecionado = this.edificios[index];
          this.descricao = this.edificioSelecionado.ED_DESCRICAO;
          this.edificio = this.edificioSelecionado.ED_NOME;
          window.scrollTo(0,0);
    },

    deleteEdificio(event){
          let codigo = event.target.dataset.codigo
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/deleteEdificio',{id:codigo})
          .then( () =>  this.getEdificios())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    }

},
  
  mounted () {
  this.getEdificios();
  }



}
</script>